let pendingRequests = 0

const LOADER_CLASS = 'global-cursor-loading'

const toggleCursorClass = () => {
  if (typeof document === 'undefined') return
  const body = document.body
  if (!body) return

  if (pendingRequests > 0) {
    body.classList.add(LOADER_CLASS)
  } else {
    body.classList.remove(LOADER_CLASS)
  }
}

export const startGlobalCursorLoader = () => {
  pendingRequests += 1
  toggleCursorClass()
}

export const stopGlobalCursorLoader = () => {
  pendingRequests = Math.max(0, pendingRequests - 1)
  toggleCursorClass()
}

export const resetGlobalCursorLoader = () => {
  pendingRequests = 0
  toggleCursorClass()
}
